import { render, staticRenderFns } from "./ClockForm.vue?vue&type=template&id=572f855e&scoped=true&"
import script from "./ClockForm.vue?vue&type=script&lang=js&"
export * from "./ClockForm.vue?vue&type=script&lang=js&"
import style0 from "./ClockForm.vue?vue&type=style&index=0&id=572f855e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "572f855e",
  null
  
)

export default component.exports